import type { RecapEntry } from '../types';

export const RECAP: RecapEntry[] = [
  {
    "key": "suspension-inferieure",
    "value": [
      {
        "recap": "Vous avez une suspension du permis inférieure à 6 mois.",
        "ordre": 1
      }
    ],
    "demarches": [],
    "articles": [
      {
        "titre": "Test Psychotechnique pour Permis : Toutes les explications",
        "article": "https://www.aaaep.fr/aaaep/test-psychotechnique-permis.html"
      },
      {
        "titre": "Test psychotechnique obligatoire en cas de suspension de permis de conduire",
        "article": "https://www.aaaep.fr/aaaep/suspension-permis-conduire-test-psychotechnique.html"
      },
      {
        "titre": "Lettre 3F et suspension administrative de permis de conduire",
        "article": "https://www.aaaep.fr/aaaep/lettre-3f-suspension-permis-conduire.html"
      },
      {
        "titre": "Test Psychotechnique et Visite Médicale pour Permis",
        "article": "https://www.aaaep.fr/aaaep/visite-medicale-et-test-psychotechnique.html"
      },
      {
        "titre": "Entrainement Inclus pour réussir son Test Psychotechnique pour permis",
        "article": "https://www.aaaep.fr/aaaep/entrainement-test-psychotechnique-permis.php"
      },
      {
        "titre": "Questions fréquentes sur les test psychotechnique pour permis",
        "article": "https://www.aaaep.fr/aaaep/questions-frequentes-test-psychotechnique-pour-permis.html"
      },
      {
        "titre": "Conduire sans Permis : Sanctions prévues par le Code de la route",
        "article": "https://www.aaaep.fr/aaaep/conduire-sans-permis-risques-sanctions.html"
      },
      {
        "titre": "Assurance auto, pénalités pour une suspension ou annulation de permis",
        "article": "https://www.aaaep.fr/aaaep/assurance-et-suspension-annulation-permis-conduire.html"
      }
    ]
  },
  {
    "key": "suspension-superieure",
    "value": [
      {
        "recap": "Vous avez une suspension du permis supérieure à 6 mois.",
        "ordre": 1
      }
    ],
    "demarches": [],
    "articles": [
      {
        "titre": "Test Psychotechnique pour Permis : Toutes les explications",
        "article": "https://www.aaaep.fr/aaaep/test-psychotechnique-permis.html"
      },
      {
        "titre": "Test psychotechnique obligatoire en cas de suspension de permis de conduire",
        "article": "https://www.aaaep.fr/aaaep/suspension-permis-conduire-test-psychotechnique.html"
      },
      {
        "titre": "Lettre 3F et suspension administrative de permis de conduire",
        "article": "https://www.aaaep.fr/aaaep/lettre-3f-suspension-permis-conduire.html"
      },
      {
        "titre": "Test Psychotechnique et Visite Médicale pour Permis",
        "article": "https://www.aaaep.fr/aaaep/visite-medicale-et-test-psychotechnique.html"
      },
      {
        "titre": "Entrainement Inclus pour réussir son Test Psychotechnique pour permis",
        "article": "https://www.aaaep.fr/aaaep/entrainement-test-psychotechnique-permis.php"
      },
      {
        "titre": "Questions fréquentes sur les test psychotechnique pour permis",
        "article": "https://www.aaaep.fr/aaaep/questions-frequentes-test-psychotechnique-pour-permis.html"
      },
      {
        "titre": "Conduire sans Permis : Sanctions prévues par le Code de la route",
        "article": "https://www.aaaep.fr/aaaep/conduire-sans-permis-risques-sanctions.html"
      },
      {
        "titre": "Assurance auto, pénalités pour une suspension ou annulation de permis",
        "article": "https://www.aaaep.fr/aaaep/assurance-et-suspension-annulation-permis-conduire.html"
      }
    ]
  },
  {
    "key": "lettre-44f",
    "value": [
      {
        "recap": "Vous avez reçu la lettre 44F",
        "ordre": 3
      },
      {
        "recap": "Vous avez le code à repasser",
        "ordre": 4
      },
      {
        "recap": "Vous avez une annulation administrative",
        "ordre": 5
      }
    ],
    "demarches": [],
    "articles": [
      {
        "titre": "Test Psychotechnique pour Permis : Toutes les explications",
        "article": "https://www.aaaep.fr/aaaep/test-psychotechnique-permis.html"
      },
      {
        "titre": "Test Psychotechnique et annulation du permis de conduire",
        "article": "https://www.aaaep.fr/aaaep/annulation-permis-conduire-test-psychotechnique.html"
      },
      {
        "titre": "Lettre 7 et l'annulation du permis de conduire",
        "article": "https://www.aaaep.fr/aaaep/lettre-reference-7-annulation-permis-conduire.html"
      },
      {
        "titre": "La lettre 44 : Annulation administrative du permis de conduire",
        "article": "https://www.aaaep.fr/aaaep/lettre-44-annulation-administrative-permis-conduire.html"
      },
      {
        "titre": "Test Psychotechnique et Visite Médicale pour Permis",
        "article": "https://www.aaaep.fr/aaaep/visite-medicale-et-test-psychotechnique.html"
      },
      {
        "titre": "Entrainement Inclus pour réussir son Test Psychotechnique pour permis",
        "article": "https://www.aaaep.fr/aaaep/entrainement-test-psychotechnique-permis.php"
      },
      {
        "titre": "Questions fréquentes sur les test psychotechnique pour permis",
        "article": "https://www.aaaep.fr/aaaep/questions-frequentes-test-psychotechnique-pour-permis.html"
      },
      {
        "titre": "Conduire sans Permis : Sanctions prévues par le Code de la route",
        "article": "https://www.aaaep.fr/aaaep/conduire-sans-permis-risques-sanctions.html"
      }
    ]
  },
  {
    "key": "lettre-7",
    "value": [
      {
        "recap": "Vous avez reçu la lettre 7",
        "ordre": 3
      },
      {
        "recap": "Vous avez le code et la conduite à repasser",
        "ordre": 4
      },
      {
        "recap": "Vous avez une annulation judiciaire",
        "ordre": 5
      }
    ],
    "demarches": [
      {
        "demarche": "Repasser le code et la conduite",
        "description": "Si permis plus de 3 ans lors du retrait, repassage du code uniquement si les démarches ont été faites dans les 9 mois; sinon, il faudra repasser le code et la conduite. Si permis moins de 3 ans lors du retrait, repassage du code et de la conduite.",
        "ordre": 5
      }
    ],
    "articles": [
      {
        "titre": "Test Psychotechnique pour Permis : Toutes les explications",
        "article": "https://www.aaaep.fr/aaaep/test-psychotechnique-permis.html"
      },
      {
        "titre": "Test Psychotechnique et annulation du permis de conduire",
        "article": "https://www.aaaep.fr/aaaep/annulation-permis-conduire-test-psychotechnique.html"
      },
      {
        "titre": "Lettre 7 et l'annulation du permis de conduire",
        "article": "https://www.aaaep.fr/aaaep/lettre-reference-7-annulation-permis-conduire.html"
      },
      {
        "titre": "La lettre 44 : Annulation administrative du permis de conduire",
        "article": "https://www.aaaep.fr/aaaep/lettre-44-annulation-administrative-permis-conduire.html"
      },
      {
        "titre": "Test Psychotechnique et Visite Médicale pour Permis",
        "article": "https://www.aaaep.fr/aaaep/visite-medicale-et-test-psychotechnique.html"
      },
      {
        "titre": "Entrainement Inclus pour réussir son Test Psychotechnique pour permis",
        "article": "https://www.aaaep.fr/aaaep/entrainement-test-psychotechnique-permis.php"
      },
      {
        "titre": "Questions fréquentes sur les test psychotechnique pour permis",
        "article": "https://www.aaaep.fr/aaaep/questions-frequentes-test-psychotechnique-pour-permis.html"
      },
      {
        "titre": "Conduire sans Permis : Sanctions prévues par le Code de la route",
        "article": "https://www.aaaep.fr/aaaep/conduire-sans-permis-risques-sanctions.html"
      }
    ]
  },
  {
    "key": "lettre-48si",
    "value": [
      {
        "recap": "Vous avez le code à repasser",
        "ordre": 3
      },
      {
        "recap": "Vous avez reçu la lettre 48SI",
        "ordre": 4
      },
      {
        "recap": "Vous avez une invalidation du permis de conduire",
        "ordre": 5
      }
    ],
    "demarches": [
      {
        "demarche": "Repasser le code",
        "description": "Si permis plus de 3 ans lors du retrait, repassage du code uniquement si les démarches ont été faites dans les 9 mois; sinon, il faudra repasser le code et la conduite. Si permis moins de 3 ans lors du retrait, repassage du code et de la conduite.",
        "ordre": 5
      }
    ],
    "articles": [
      {
        "titre": "Test Psychotechnique pour Permis : Toutes les explications",
        "article": "https://www.aaaep.fr/aaaep/test-psychotechnique-permis.html"
      },
      {
        "titre": "Invalidation du permis : Le test psychotechnique pour un nouveau Permis",
        "article": "https://www.aaaep.fr/aaaep/invalidation-permis-conduire-test-psychotechnique.html"
      },
      {
        "titre": "Lettre 7 et l'annulation du permis de conduire",
        "article": "https://www.aaaep.fr/aaaep/lettre-reference-7-annulation-permis-conduire.html"
      },
      {
        "titre": "La lettre 44 : Annulation administrative du permis de conduire",
        "article": "https://www.aaaep.fr/aaaep/lettre-44-annulation-administrative-permis-conduire.html"
      },
      {
        "titre": "Test Psychotechnique et Visite Médicale pour Permis",
        "article": "https://www.aaaep.fr/aaaep/visite-medicale-et-test-psychotechnique.html"
      },
      {
        "titre": "Entrainement Inclus pour réussir son Test Psychotechnique pour permis",
        "article": "https://www.aaaep.fr/aaaep/entrainement-test-psychotechnique-permis.php"
      },
      {
        "titre": "Questions fréquentes sur les test psychotechnique pour permis",
        "article": "https://www.aaaep.fr/aaaep/questions-frequentes-test-psychotechnique-pour-permis.html"
      },
      {
        "titre": "Conduire sans Permis : Sanctions prévues par le Code de la route",
        "article": "https://www.aaaep.fr/aaaep/conduire-sans-permis-risques-sanctions.html"
      }
    ]
  },
  {
    "key": "mr-alcoolemie",
    "value": [
      {
        "recap": "Vous avez un retrait de votre permis de conduire.",
        "ordre": 0
      },
      {
        "recap": "Vous avez eu un retrait de permis pour alcoolémie",
        "ordre": 2
      }
    ],
    "demarches": [
      {
        "demarche": "Test psychotechnique",
        "description": "Il faut commencer les démarches à partir de 3 mois.",
        "ordre": 0
      },
      {
        "demarche": "Téléchargez votre CERFA",
        "description": "",
        "ordre": 1
      },
      {
        "demarche": "Analyse sanguin en laboratoire",
        "description": "L'analyse en laboratoire doit s'effectuer 2 semaines ou moins avant le rendez-vous à la commission médicale.",
        "ordre": 2
      },
      {
        "demarche": "Visite médicale en commission médicale de la préfecture",
        "description": "La prise de rendez-vous se fait directement sur le site de la préfecture.",
        "ordre": 3
      },
      {
        "demarche": "Démarches sur le site de l'ANTS",
        "description": "",
        "ordre": 4
      }
    ],
    "articles": [
      {
        "titre": "Alcool, stupéfiants et récidive au volant",
        "article": "https://www.aaaep.fr/aaaep/alcool-stupefiants-recidive-risques-sanction-permis-conduire.html"
      }
    ]
  },
  {
    "key": "mr-stupefiant",
    "value": [
      {
        "recap": "Vous avez un retrait de votre permis de conduire.",
        "ordre": 0
      },
      {
        "recap": "Vous avez eu un retrait de permis pour consommation de stupéfiant.",
        "ordre": 2
      }
    ],
    "demarches": [
      {
        "demarche": "Test psychotechnique",
        "description": "Il faut commencer les démarches à partir de 3 mois.",
        "ordre": 0
      },
      {
        "demarche": "Téléchargez votre CERFA",
        "description": "",
        "ordre": 1
      },
      {
        "demarche": "Analyse urinaire en laboratoire",
        "description": "L'analyse en laboratoire doit s'effectuer 2 semaines ou moins avant le rendez-vous à la commission médicale.",
        "ordre": 2
      },
      {
        "demarche": "Visite médicale en commission médicale de la préfecture",
        "description": "La prise de rendez-vous se fait directement sur le site de la préfecture.",
        "ordre": 3
      },
      {
        "demarche": "Démarches sur le site de l'ANTS",
        "description": "",
        "ordre": 4
      }
    ],
    "articles": [
      {
        "titre": "Alcool, stupéfiants et récidive au volant",
        "article": "https://www.aaaep.fr/aaaep/alcool-stupefiants-recidive-risques-sanction-permis-conduire.html"
      }
    ]
  },
  {
    "key": "mr-double",
    "value": [
      {
        "recap": "Vous avez un retrait de votre permis de conduire.",
        "ordre": 0
      },
      {
        "recap": "Vous avez un retrait de permis pour alcoolémie et stupéfiants",
        "ordre": 2
      }
    ],
    "demarches": [
      {
        "demarche": "Test psychotechnique",
        "description": "Il faut commencer les démarches à partir de 3 mois.",
        "ordre": 0
      },
      {
        "demarche": "Téléchargez votre CERFA",
        "description": "",
        "ordre": 1
      },
      {
        "demarche": "Analyse sanguin et urinaire en laboratoire",
        "description": "L'analyse en laboratoire doit s'effectuer 2 semaines ou moins avant le rendez-vous à la commission médicale.",
        "ordre": 2
      },
      {
        "demarche": "Visite médicale en commission médicale de la préfecture",
        "description": "La prise de rendez-vous se fait directement sur le site de la préfecture.",
        "ordre": 3
      },
      {
        "demarche": "Démarches sur le site de l'ANTS",
        "description": "",
        "ordre": 4
      }
    ],
    "articles": [
      {
        "titre": "Alcool, stupéfiants et récidive au volant",
        "article": "https://www.aaaep.fr/aaaep/alcool-stupefiants-recidive-risques-sanction-permis-conduire.html"
      }
    ]
  },
  {
    "key": "mr-autres",
    "value": [
      {
        "recap": "Vous avez un retrait de votre permis de conduire.",
        "ordre": 0
      },
      {
        "recap": "Vous avez eu un retrait de permis suite à une perte de point, d'excès de vitesse ou autre.",
        "ordre": 2
      }
    ],
    "demarches": [
      {
        "demarche": "Test psychotechnique",
        "description": "Il faut commencer les démarches à partir de 3 mois.",
        "ordre": 0
      },
      {
        "demarche": "Téléchargez votre CERFA",
        "description": "",
        "ordre": 1
      },
      {
        "demarche": "Visite médicale chez un médecin agréé",
        "description": "La liste des médecins agréés se trouve sur le site de la préfecture.",
        "ordre": 2
      },
      {
        "demarche": "Démarches sur le site de l'ANTS",
        "description": "",
        "ordre": 3
      }
    ],
    "articles": []
  }
];
